<template>
  <div class="text-start mx-1">
    <v-dialog v-model="isOpen" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-icon small color="orange darken-2" class="mx-2" v-bind="attrs" v-on="on">local_shipping</v-icon>
      </template>
      <v-card>
        <v-card-title class="text-h5 lighten-2">Out for Delivery</v-card-title>
        <v-card-text class="text-body lighten-2">
          This will change status to 'Out for Delivery' and send SMS to the user.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleClose"> Cancel </v-btn>
          <v-btn color="primary" text @click="handleSubmit"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PrescriptionService from '../../../services/prescription';

export default {
  name: 'AddOutForDeliveryDialog',
  props: ['epresOrder', 'onSubmitted'],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    handleClose() {
      this.isOpen = false;
    },
    handleSubmit() {
      const prescriptionId = this.epresOrder.value._id;
      const { userId, orderNumber } = this.epresOrder;
      const param = {
        prescriptionId,
        patientId: userId,
        orderNumber,
      };

      PrescriptionService.updateOutForDelivery(prescriptionId, param)
        .then(() => {
          if (this.onSubmitted) {
            this.isOpen = false;
            this.onSubmitted();
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
